// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1333333333);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FormFields/Loader/loader.scss"],"names":[],"mappings":"AAAA;EACC,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACD;;AACA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,mDAAA;AAED;;AAAA;EACC,SAAA;EACA,sCAAA;AAGD;;AADA;EACC,SAAA;EACA,sCAAA;AAID;;AAFA;EACC,UAAA;EACA,sCAAA;AAKD;;AAHA;EACC,UAAA;EACA,sCAAA;AAMD;;AAJA;EACC;IACC,mBAAA;EAOA;EALD;IACC,mBAAA;EAOA;AACF;AALA;EACC;IACC,mBAAA;EAOA;EALD;IACC,mBAAA;EAOA;AACF;AALA;EACC;IACC,0BAAA;EAOA;EALD;IACC,6BAAA;EAOA;AACF","sourcesContent":[".lds-ellipsis {\n\tdisplay: inline-block;\n\tposition: relative;\n\twidth: 80px;\n\theight: 80px;\n}\n.lds-ellipsis div {\n\tposition: absolute;\n\ttop: 33px;\n\twidth: 13px;\n\theight: 13px;\n\tborder-radius: 50%;\n\tbackground: #ffffff22;\n\tanimation-timing-function: cubic-bezier(0, 1, 1, 0);\n}\n.lds-ellipsis div:nth-child(1) {\n\tleft: 8px;\n\tanimation: lds-ellipsis1 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(2) {\n\tleft: 8px;\n\tanimation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(3) {\n\tleft: 32px;\n\tanimation: lds-ellipsis2 0.6s infinite;\n}\n.lds-ellipsis div:nth-child(4) {\n\tleft: 56px;\n\tanimation: lds-ellipsis3 0.6s infinite;\n}\n@keyframes lds-ellipsis1 {\n\t0% {\n\t\ttransform: scale(0);\n\t}\n\t100% {\n\t\ttransform: scale(1);\n\t}\n}\n@keyframes lds-ellipsis3 {\n\t0% {\n\t\ttransform: scale(1);\n\t}\n\t100% {\n\t\ttransform: scale(0);\n\t}\n}\n@keyframes lds-ellipsis2 {\n\t0% {\n\t\ttransform: translate(0, 0);\n\t}\n\t100% {\n\t\ttransform: translate(24px, 0);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
